import {useQuery} from "@tanstack/react-query";
import {
    getUserChainListApi,
    getUserImportTokenListApi,
    getUserWalletAssetApi, getWalletAssetListApi, getWalletChainListApi, getWalletNftListApi,
} from "../../api";
import {isSuccess} from "../../api/request";
import type {UseQueryOptions} from "@tanstack/react-query/src/types";
import {
    UserAssetToken,
    UserChainType,
    UserImportTokenType,
    UserTransactionType, WalletAssetType,
    WalletChainType,
    WalletNFTType
} from "../../types";
import useUserInfo from "../useUserInfo";

export {userImportTokenApi, getUserWalletTransactionsApi, getWalletAssetListApi, getWalletListApi} from "../../api"

export function useChainListQuery(options?: Partial<Omit<UseQueryOptions<UserChainType[]>, 'queryKey' | 'queryFn'>>) {
    const {isLogin, token} = useUserInfo()
    return useQuery({
        queryKey: ["match-user-chain-list", token],
        queryFn: async () => {
            const res = await getUserChainListApi()
            if (!isSuccess(res)) {
                return []
            }
            return res.data
        },
        enabled: isLogin,
        ...options
    })

}


export function useAssetListQuery({
                                      chainId,
                                      ...options
                                  }: {
    chainId: number
} & Partial<Omit<UseQueryOptions<UserAssetToken[]>, 'queryKey' | 'queryFn'>>) {
    const {isLogin, token} = useUserInfo()
    return useQuery({
        queryKey: ["match-user-asset-list", token, chainId],
        queryFn: async () => {
            const res = await getUserWalletAssetApi({chain_id: chainId.toString()})
            if (!isSuccess(res)) {
                return []
            }
            return res.data || []
        },
        enabled: isLogin,
        ...options
    })
}
export const USER_IMPORT_TOKEN_LIST_KEY = "match-user-import-token-list"
export function useImportTokenListQuery({
                                            chainId,
                                            ...options
                                        }: {
    chainId: number
} & Partial<Omit<UseQueryOptions<UserImportTokenType[]>, 'queryKey' | 'queryFn'>>) {
    const {isLogin, token} = useUserInfo()
    return useQuery({
        queryKey: [USER_IMPORT_TOKEN_LIST_KEY, token, chainId],
        queryFn: async () => {
            const res = await getUserImportTokenListApi({chain_id: chainId.toString()})
            if (!isSuccess(res)) {
                return []
            }
            return res.data || []
        },
        enabled: isLogin,
        ...options
    })
}

export function useWalletChainListQuery(options?: Partial<Omit<UseQueryOptions<WalletChainType[]>, 'queryKey' | 'queryFn'>>) {
    const {isLogin, token} = useUserInfo()
    return useQuery({
        queryKey: ["match-wallet-chain-list", token],
        queryFn: async () => {
            const res = await getWalletChainListApi()
            if (!isSuccess(res)) {
                return []
            }
            return res.data
        },
        enabled: isLogin,
        ...options
    })

}

export function useWalletNftListQuery({
                                          chainId,
                                          address,
                                          ...options
                                      }: {
    chainId: string,
    address: string
} & Partial<Omit<UseQueryOptions<WalletNFTType[]>, 'queryKey' | 'queryFn'>>) {
    const {isLogin, token} = useUserInfo()
    return useQuery({
        queryKey: ["match-wallet-nft-list", token, chainId, address],
        queryFn: async () => {
            const res = await getWalletNftListApi({
                chain_id: chainId.toString(),
                address
            })
            if (!isSuccess(res)) {
                return []
            }
            return res.data
        },
        enabled: isLogin,
        ...options
    })

}

export function useWalletAssetListQuery({
                                          chainId,
                                          address,
                                          ...options
                                      }: {
    chainId: string,
    address: string
} & Partial<Omit<UseQueryOptions<{
    asset_list:WalletAssetType[]
    asset_total_balance:string
}|null>, 'queryKey' | 'queryFn'>>) {
    const {isLogin, token} = useUserInfo()
    return useQuery({
        queryKey: ["match-wallet-asset-list", token, chainId, address],
        queryFn: async () => {
            const res = await getWalletAssetListApi({
                chain_id: chainId,
                address
            })
            if (!isSuccess(res)) {
                return null
            }
            return res.data
        },
        enabled: isLogin,
        ...options
    })

}